import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "../axios";

export default function Campaign() {
  const location = useLocation();
  const selected = location.state?.selected || [];

  const [message, setMessage] = useState("");
  const [schedule, setSchedule] = useState("");
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [sending, setSending] = useState(false);
  const [scheduling, setScheduling] = useState(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const res = await axios.get("/templates");
        setTemplates(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchTemplates();
  }, []);

  const sendCampaign = async () => {
    if (selected.length === 0) return alert("No contacts selected");
    if (!message.trim()) return alert("Message required");
    try {
      setSending(true);
      const temp = templates.find((t) => String(t.id) === String(selectedTemplate));
      const res = await axios.post("/campaigns/send", {
        message,
        contact_ids: selected,
        template: temp || null,
      });
      alert(res.data.msg || "Campaign Sent 🚀");
    } catch (err) {
      alert(err.response?.data?.msg || "Something went wrong");
    } finally {
      setSending(false);
    }
  };

  const scheduleCampaign = async () => {
    if (selected.length === 0) return alert("No contacts selected");
    if (!message.trim()) return alert("Message required");
    if (!schedule) return alert("Select date & time");
    try {
      setScheduling(true);
      const temp = templates.find((t) => String(t.id) === String(selectedTemplate));
      const res = await axios.post("/campaigns/schedule", {
        message,
        contact_ids: selected,
        scheduled_at: schedule,
        template: temp || null,
      });
      alert(res.data.msg || "Campaign Scheduled ⏳");
    } catch (err) {
      alert(err.response?.data?.msg || "Schedule failed");
    } finally {
      setScheduling(false);
    }
  };

  const charCount = message.length;
  const selectedTemp = templates.find((t) => String(t.id) === String(selectedTemplate));

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

        .campaign-page * {
          font-family: 'Sora', sans-serif;
          box-sizing: border-box;
        }

        .campaign-page {
          background: #f0f2f8;
          min-height: 100vh;
          padding: 28px 32px;
        }

        /* Header */
        .campaign-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
          gap: 12px;
          flex-wrap: wrap;
        }

        .campaign-title-wrap {
          display: flex;
          align-items: center;
          gap: 14px;
          min-width: 0;
        }

        .campaign-icon {
          width: 46px;
          height: 46px;
          border-radius: 14px;
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          box-shadow: 0 4px 14px rgba(37,99,235,0.35);
          flex-shrink: 0;
        }

        .campaign-title {
          font-size: 22px;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.5px;
        }

        .campaign-subtitle {
          font-size: 12px;
          color: #94a3b8;
          font-weight: 400;
          margin-top: 1px;
        }

        /* Audience chip */
        .audience-chip {
          display: flex;
          align-items: center;
          gap: 8px;
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 20px;
          padding: 8px 16px;
          font-size: 13px;
          font-weight: 600;
          color: #475569;
          box-shadow: 0 1px 4px rgba(15,23,42,0.05);
          white-space: nowrap;
        }

        .audience-chip .count {
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          color: #fff;
          border-radius: 12px;
          padding: 2px 10px;
          font-size: 12px;
          font-weight: 700;
        }

        /* Main grid */
        .campaign-grid {
          display: grid;
          grid-template-columns: 1fr 360px;
          gap: 16px;
          align-items: start;
        }

        /* Cards */
        .camp-card {
          background: #fff;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 2px 16px rgba(15,23,42,0.07);
          border: 1px solid #e8ecf4;
          margin-bottom: 16px;
        }

        .camp-card-header {
          padding: 14px 20px;
          border-bottom: 1px solid #f1f5f9;
          display: flex;
          align-items: center;
          gap: 10px;
          background: #fafbff;
        }

        .camp-card-icon {
          width: 30px;
          height: 30px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          flex-shrink: 0;
        }

        .icon-blue { background: #eff6ff; }
        .icon-purple { background: #f5f3ff; }
        .icon-green { background: #f0fdf4; }

        .camp-card-title {
          font-size: 13px;
          font-weight: 600;
          color: #475569;
          text-transform: uppercase;
          letter-spacing: 0.6px;
        }

        .camp-card-body {
          padding: 18px 20px;
        }

        /* Template Select */
        .template-select-wrap {
          position: relative;
        }

        .template-select {
          width: 100%;
          appearance: none;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          padding: 11px 40px 11px 14px;
          font-size: 13.5px;
          font-family: 'Sora', sans-serif;
          color: #0f172a;
          outline: none;
          background: #f8fafc;
          cursor: pointer;
          transition: all 0.2s;
        }

        .template-select:focus {
          border-color: #2563eb;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.08);
        }

        .select-arrow {
          position: absolute;
          right: 13px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          pointer-events: none;
          font-size: 12px;
        }

        /* Template preview */
        .template-preview {
          margin-top: 12px;
          padding: 12px 14px;
          background: #f8fafc;
          border-radius: 10px;
          border: 1px solid #f1f5f9;
        }

        .template-preview-label {
          font-size: 10.5px;
          font-weight: 600;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 6px;
        }

        .template-type-tag {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 6px;
          background: #faf5ff;
          color: #7e22ce;
          border: 1px solid #e9d5ff;
          margin-bottom: 8px;
        }

        .template-preview-text {
          font-size: 12.5px;
          color: #475569;
          line-height: 1.5;
          word-break: break-word;
        }

        /* Message textarea */
        .msg-wrap {
          position: relative;
        }

        .msg-textarea {
          width: 100%;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          padding: 13px 14px;
          font-size: 13.5px;
          font-family: 'Sora', sans-serif;
          color: #0f172a;
          outline: none;
          resize: vertical;
          min-height: 160px;
          background: #f8fafc;
          transition: all 0.2s;
          line-height: 1.6;
        }

        .msg-textarea:focus {
          border-color: #2563eb;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.08);
        }

        .msg-textarea::placeholder { color: #94a3b8; }

        .char-count {
          text-align: right;
          font-size: 11px;
          color: #94a3b8;
          margin-top: 6px;
          font-family: 'JetBrains Mono', monospace;
        }

        .char-count.warn { color: #ea580c; }

        /* Preview bubble */
        .preview-bubble {
          background: #f0fdf4;
          border: 1px solid #bbf7d0;
          border-radius: 14px;
          padding: 13px 15px;
          font-size: 13px;
          color: #166534;
          line-height: 1.6;
          white-space: pre-wrap;
          margin-top: 12px;
          min-height: 60px;
          word-break: break-word;
        }

        .preview-bubble.empty {
          color: #94a3b8;
          font-style: italic;
          background: #f8fafc;
          border-color: #f1f5f9;
        }

        /* Schedule input */
        .schedule-input {
          width: 100%;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          padding: 11px 14px;
          font-size: 13.5px;
          font-family: 'Sora', sans-serif;
          color: #0f172a;
          outline: none;
          background: #f8fafc;
          transition: all 0.2s;
        }

        .schedule-input:focus {
          border-color: #2563eb;
          background: #fff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.08);
        }

        .schedule-set {
          margin-top: 10px;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          color: #059669;
          font-weight: 600;
          word-break: break-word;
        }

        /* Action buttons */
        .action-card {
          background: #fff;
          border-radius: 20px;
          padding: 20px;
          box-shadow: 0 2px 16px rgba(15,23,42,0.07);
          border: 1px solid #e8ecf4;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .btn-send-now {
          width: 100%;
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 13px;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          font-family: 'Sora', sans-serif;
          transition: all 0.18s;
          box-shadow: 0 3px 12px rgba(37,99,235,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .btn-send-now:hover {
          transform: translateY(-1px);
          box-shadow: 0 5px 18px rgba(37,99,235,0.4);
        }

        .btn-send-now:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
        }

        .btn-schedule {
          width: 100%;
          background: linear-gradient(135deg, #059669, #10b981);
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 13px;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          font-family: 'Sora', sans-serif;
          transition: all 0.18s;
          box-shadow: 0 3px 12px rgba(5,150,105,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .btn-schedule:hover {
          transform: translateY(-1px);
          box-shadow: 0 5px 18px rgba(5,150,105,0.4);
        }

        .btn-schedule:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
        }

        .divider {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #cbd5e1;
          font-size: 12px;
        }

        .divider::before,
        .divider::after {
          content: '';
          flex: 1;
          height: 1px;
          background: #f1f5f9;
        }

        /* Stats row */
        .stats-row {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          margin-bottom: 16px;
        }

        .stat-card {
          background: #fff;
          border-radius: 16px;
          padding: 16px 18px;
          box-shadow: 0 2px 10px rgba(15,23,42,0.06);
          border: 1px solid #e8ecf4;
          min-width: 0;
        }

        .stat-label {
          font-size: 11px;
          font-weight: 600;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 6px;
        }

        .stat-value {
          font-size: 22px;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .stat-value.blue { color: #2563eb; }
        .stat-value.green { color: #059669; }
        .stat-value.purple { color: #7c3aed; }

        .stat-sub {
          font-size: 11px;
          color: #94a3b8;
          margin-top: 2px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        /* ===================== TABLET ===================== */
        @media (max-width: 980px) {
          .campaign-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 860px) {
          .campaign-page {
            padding: 20px 18px;
          }

          .stats-row {
            grid-template-columns: repeat(3, 1fr);
            gap: 10px;
          }

          .stat-card {
            padding: 14px 14px;
          }

          .stat-value {
            font-size: 19px;
          }
        }

        /* ===================== MOBILE ===================== */
        @media (max-width: 640px) {
          .campaign-page {
            padding: 16px 12px;
          }

          .campaign-header {
            margin-bottom: 18px;
          }

          .campaign-icon {
            width: 40px;
            height: 40px;
            font-size: 17px;
            border-radius: 12px;
          }

          .campaign-title {
            font-size: 18px;
          }

          .campaign-subtitle {
            font-size: 11px;
          }

          .audience-chip {
            padding: 6px 12px;
            font-size: 12px;
          }

          .stats-row {
            grid-template-columns: 1fr 1fr;
            gap: 8px;
          }

          .stat-card {
            padding: 12px;
            border-radius: 14px;
          }

          .stat-value {
            font-size: 18px;
          }

          .camp-card {
            border-radius: 16px;
            margin-bottom: 12px;
          }

          .camp-card-header {
            padding: 12px 14px;
          }

          .camp-card-body {
            padding: 14px;
          }

          .msg-textarea {
            min-height: 130px;
          }

          .action-card {
            padding: 16px;
            border-radius: 16px;
          }

          .btn-send-now,
          .btn-schedule {
            padding: 12px;
            font-size: 13.5px;
          }
        }

        @media (max-width: 420px) {
          .stats-row {
            grid-template-columns: 1fr;
          }

          .campaign-title {
            font-size: 16px;
          }

          .campaign-icon {
            width: 36px;
            height: 36px;
            font-size: 15px;
          }
        }
      `}</style>

      <div className="campaign-page">
        {/* Header */}
        <div className="campaign-header">
          <div className="campaign-title-wrap">
            <div className="campaign-icon">📣</div>
            <div>
              <div className="campaign-title">Send Campaign</div>
              <div className="campaign-subtitle">Broadcast to your audience</div>
            </div>
          </div>
          <div className="audience-chip">
            Audience
            <span className="count">{selected.length} contacts</span>
          </div>
        </div>

        {/* Stats Row */}
        <div className="stats-row">
          <div className="stat-card">
            <div className="stat-label">Recipients</div>
            <div className="stat-value blue">{selected.length}</div>
            <div className="stat-sub">contacts selected</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Templates</div>
            <div className="stat-value purple">{templates.length}</div>
            <div className="stat-sub">available</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Status</div>
            <div className="stat-value green">{schedule ? "Scheduled" : "Instant"}</div>
            <div className="stat-sub">{schedule ? schedule.slice(0, 16).replace("T", " ") : "send immediately"}</div>
          </div>
        </div>

        {/* Main Grid */}
        <div className="campaign-grid">
          {/* Left column */}
          <div>
            {/* Template */}
            <div className="camp-card">
              <div className="camp-card-header">
                <div className="camp-card-icon icon-purple">🗂</div>
                <div className="camp-card-title">Choose Template</div>
              </div>
              <div className="camp-card-body">
                <div className="template-select-wrap">
                  <select
                    className="template-select"
                    value={selectedTemplate}
                    onChange={(e) => {
                      const id = e.target.value;
                      setSelectedTemplate(id);
                      const temp = templates.find((t) => String(t.id) === String(id));
                      if (temp) setMessage(temp.message || "");
                    }}
                  >
                    <option value="">— Select a Template —</option>
                    {templates.map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name} ({t.type})
                      </option>
                    ))}
                  </select>
                  <span className="select-arrow">▾</span>
                </div>

                {selectedTemp && (
                  <div className="template-preview">
                    <div className="template-preview-label">Preview</div>
                    <div className="template-type-tag">{selectedTemp.type}</div>
                    <div className="template-preview-text">
                      {selectedTemp.message || "No preview available"}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Message */}
            <div className="camp-card">
              <div className="camp-card-header">
                <div className="camp-card-icon icon-blue">✉️</div>
                <div className="camp-card-title">Message</div>
              </div>
              <div className="camp-card-body">
                <div className="msg-wrap">
                  <textarea
                    className="msg-textarea"
                    placeholder="Type your campaign message here..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>
                <div className={`char-count ${charCount > 1000 ? "warn" : ""}`}>
                  {charCount} characters
                </div>

                {/* Live preview */}
                <div style={{ marginTop: 8 }}>
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>
                    Live Preview
                  </div>
                  <div className={`preview-bubble ${!message.trim() ? "empty" : ""}`}>
                    {message.trim() || "Your message will appear here..."}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right column */}
          <div>
            {/* Schedule */}
            <div className="camp-card">
              <div className="camp-card-header">
                <div className="camp-card-icon icon-green">⏱</div>
                <div className="camp-card-title">Schedule (Optional)</div>
              </div>
              <div className="camp-card-body">
                <input
                  type="datetime-local"
                  className="schedule-input"
                  value={schedule}
                  onChange={(e) => setSchedule(e.target.value)}
                />
                {schedule && (
                  <div className="schedule-set">
                    ✓ Scheduled for {schedule.replace("T", " at ")}
                  </div>
                )}
                {!schedule && (
                  <div style={{ marginTop: 8, fontSize: 12, color: "#94a3b8" }}>
                    Leave empty to send immediately
                  </div>
                )}
              </div>
            </div>

            {/* Actions */}
            <div className="action-card">
              <button
                className="btn-send-now"
                onClick={sendCampaign}
                disabled={sending || selected.length === 0 || !message.trim()}
              >
                {sending ? "⏳ Sending..." : "🚀 Send Now"}
              </button>

              <div className="divider">or</div>

              <button
                className="btn-schedule"
                onClick={scheduleCampaign}
                disabled={scheduling || selected.length === 0 || !message.trim() || !schedule}
              >
                {scheduling ? "⏳ Scheduling..." : "📅 Schedule Campaign"}
              </button>

              {selected.length === 0 && (
                <div style={{ fontSize: 12, color: "#ef4444", textAlign: "center", marginTop: 4 }}>
                  ⚠ No contacts selected
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}